export const menu = [
  {
    title: 'Home',
    path: '/',
  },
  {
    title: 'Spotlight',
    path: '/spotlight',
  },
  {
    title: 'Our Tech Stack',
    path: '/tech',
  },
  {
    title: 'Our Team',
    path: '/team',
  },
];
